/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import IframeView from '@components/IframeView';

/* Constants */
import { PAGE_TYPE_LOCATION } from '@constants/pages';
import { GetStaticProps } from 'next';
import { ParsedUrlQuery } from 'querystring';

type FAQPagesProps = {
  src: string;
};

interface StaticParams extends ParsedUrlQuery {
  faqPage: string;
}

const faqPagesToIframe = {
  membership: { src: 'https://help.hellotech.com/en_us/how-does-the-no-risk-hellotech-membership-guarantee-work-HJJd49hXI' },
};

function FAQPages(props: FAQPagesProps) {
  return (
    <div>
      <IframeView callerPageName="faq" src={props.src} />
    </div>
  );
}

FAQPages.pageAttributes = { page: PAGE_TYPE_LOCATION };
FAQPages.Layout = getLayout({ promo: true, footer: true });

export const getStaticProps: GetStaticProps = async context => {
  const params = context.params as StaticParams;

  return {
    props: {
      src: (faqPagesToIframe as Record<string, { src: string }>)[params.faqPage].src,
    },
  };
};

export async function getStaticPaths<GetStaticPaths>() {
  const allFaq = Object.keys(faqPagesToIframe).map(key => ({
    params: {
      faqPage: key,
    },
  }));

  return {
    paths: allFaq,
    fallback: true,
  };
}

export default FAQPages;
